import {useId,useState,useSyncExternalStore} from 'react';
import {ConfirmationDialog} from './ConfirmationDialog';
import {currentConfirmRequest,settleConfirmRequest,subscribeConfirmRequests} from './confirm-action';

/** Mounted once in the staff shell; shows the confirmation requested through confirmAction or confirmWithReason. */
export function ConfirmationHost(){
 const request=useSyncExternalStore(subscribeConfirmRequests,currentConfirmRequest,()=>null);
 const[reason,setReason]=useState(''),reasonId=useId();
 const needed=request?.reason,valid=!needed||reason.trim().length>=needed.minLength;
 const close=(value:string|null)=>{setReason('');settleConfirmRequest(value);};
 if(!request)return null;
 return <ConfirmationDialog open title={request.title} description={request.description} confirmLabel={request.confirmLabel} busyLabel={request.confirmLabel}
  cancelLabel={request.cancelLabel??'Cancel'} tone={request.tone??'warning'} confirmDisabled={!valid}
  onConfirm={()=>close(needed?reason.trim():'')} onCancel={()=>close(null)}>
  {needed&&<label htmlFor={reasonId} className="confirmation-dialog__reason">{needed.label}
   <textarea id={reasonId} required={needed.minLength>0} minLength={needed.minLength||undefined} maxLength={needed.maxLength??1000} rows={3} value={reason} onChange={event=>setReason(event.target.value)}/>
   {needed.minLength>0&&<span className="form-help">At least {needed.minLength} characters.{reason.trim().length<needed.minLength?` ${needed.minLength-reason.trim().length} more needed.`:''}</span>}
  </label>}
 </ConfirmationDialog>;
}
